// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-danke-js": require("gatsby-module-loader?name=component---src-pages-danke-js!/opt/build/repo/src/pages/danke.js"),
  "component---src-pages-datenschutz-js": require("gatsby-module-loader?name=component---src-pages-datenschutz-js!/opt/build/repo/src/pages/datenschutz.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "danke.json": require("gatsby-module-loader?name=path---danke!/opt/build/repo/.cache/json/danke.json"),
  "datenschutz.json": require("gatsby-module-loader?name=path---datenschutz!/opt/build/repo/.cache/json/datenschutz.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js